import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { PricingHero } from "@/components/site/PricingHero";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { primaryVideoObject } from "@/lib/video-seo";
import { safeJsonLd } from "@/lib/structured-data-core";

const PricingFaqAccordion = lazy(() =>
  import("@/components/site/PricingFaqAccordion").then((m) => ({ default: m.PricingFaqAccordion })),
);
const Guarantee = lazy(() => import("@/components/site/Guarantee").then((m) => ({ default: m.Guarantee })));
const PricingClientResults = lazy(() =>
  import("@/components/site/PricingClientResults").then((m) => ({ default: m.PricingClientResults })),
);
const Faq = lazy(() => import("@/components/site/Faq").then((m) => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then((m) => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/pricing")({
  head: () => ({
    meta: [
      { title: "Hair Transplant Pricing | Save $1,000 — RESTORE® Hair" },
      {
        name: "description",
        content:
          "How much does a hair transplant cost? Get a quick quote and save $1,000 on your FUE hair transplant procedure with RESTORE® Hair. Financing available.",
      },
      { property: "og:title", content: "Hair Transplant Pricing | Save $1,000 — RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "Invest in yourself. Save $1,000 on your FUE hair transplant. Low-interest financing available.",
      },
      { property: "og:url", content: "https://restorehair.com/pricing/" },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/pricing/" },
      {
        rel: "preload",
        as: "image",
        href: "https://assets.restorehair.com/lp/zach-kevin-hero.webp",
        fetchpriority: "high",
      },
    ],
    scripts: [{
      type: "application/ld+json",
      children: safeJsonLd(primaryVideoObject("/pricing/")),
    }],
  }),
  component: PricingPage,
});

function PricingPage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <PricingHero />
        <NorwoodQuiz />
        <Suspense fallback={null}>
          <PricingFaqAccordion />
          <Guarantee />
          <PricingClientResults />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}